const auth = {
  login: null,
  register: null,
  requestPasswordReset: null,
  passwordReset: null,
  verifiedAccount: null,
};

export default auth;
